import { useEffect, useState } from "react";
import axios from 'axios';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function MobileMenu({ isOpen, setIsOpen }) {
    const toggleMenu = () => setIsOpen(!isOpen);
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(null);

    // Проверяем, арабский ли язык
    const isArabic = i18n.language === 'ar';

    useEffect(() => {
        axios.get('https://api.compcoretech.com/api/data/getVisible')
            .then(response => setIsVisible(response.data))
            .catch(error => console.error('Ошибка при получении видимости:', error));
    }, []);

    return (
        <div>
            {/* Кнопка-бургер */}
            <div
                className="h-[30px] flex items-center w-[62px] cursor-pointer z-[999] relative"
                onClick={toggleMenu}
            >
                <div className="w-[30px] h-[11px] flex flex-col justify-between cursor-pointer">
                    <div className={`h-[1px] transition duration-300 transform w-[62px] bg-[#FFFFFF] ${isOpen ? 'rotate-12 translate-y-[5px]' : ''}`}></div>
                    <div className={`h-[1px] transition duration-300 transform w-[62px] bg-[#FFFFFF] ${isOpen ? '-rotate-12 -translate-y-[5px]' : ''}`}></div>
                </div>
            </div>

            {/* Мобильное меню */}
            <div
                className={`fixed top-0 bottom-0 w-full md:w-1/2 xl:w-1/3 mobmenubg z-50 transform transition-all duration-300
                    ${isArabic
                        ? `${isOpen ? 'translate-x-0 left-0' : '-translate-x-full left-0'}`
                        : `${isOpen ? 'translate-x-0 right-0' : 'translate-x-full right-0'}`
                    }`}
            >
                <div className="flex flex-col mt-[170px] gap-[15px] xl:gap-[5px] items-center xl:pl-[60px]">
                    <p className="text-[18px] open-sans text-[#F6F6F6]">{t('header.1')}:</p>
                    <Link to="/composite-rein">
                        <p className={`text-[18px] open-sans ${location.pathname === '/composite-rein' ? 'text-[#F26522]' : 'text-[#9B9B9B]'}`} onClick={toggleMenu}>{t('header.2')}</p>
                    </Link>
                    <Link to="/composite-mesh">
                        <p className={`text-[18px] open-sans ${location.pathname === '/composite-mesh' ? 'text-[#F26522]' : 'text-[#9B9B9B]'}`} onClick={toggleMenu}>{t('header.3')}</p>
                    </Link>
                    <Link to="/masonry-mesh">
                        <p className={`text-[18px] open-sans ${location.pathname === '/masonry-mesh' ? 'text-[#F26522]' : 'text-[#9B9B9B]'}`} onClick={toggleMenu}>{t('header.4')}</p>
                    </Link>
                    {isVisible === true && (
                        <Link to="/calculator">
                            <p className={`text-[18px] open-sans ${location.pathname === '/calculator' ? 'text-[#F26522]' : 'text-[#9B9B9B]'}`} onClick={toggleMenu}>{t('header.6')}</p>
                        </Link>
                    )}
                    <Link to="/about-us">
                        <p className={`text-[18px] open-sans mt-[40px] ${location.pathname === '/about-us' ? 'text-[#F26522]' : 'text-[#F6F6F6]'}`} onClick={toggleMenu}>{t('header.5')}</p>
                    </Link>
                    {/* <Link to="/news">
                        <p className={`text-[18px] open-sans ${location.pathname === '/news' ? 'text-[#F26522]' : 'text-[#F6F6F6]'}`} onClick={toggleMenu}>{t('header.7')}</p>
                    </Link> */}
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
